import { render, staticRenderFns } from "./LogisticTraceability.vue?vue&type=template&id=4991442e&scoped=true"
import script from "./LogisticTraceability.vue?vue&type=script&lang=js"
export * from "./LogisticTraceability.vue?vue&type=script&lang=js"
import style0 from "./LogisticTraceability.vue?vue&type=style&index=0&id=4991442e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4991442e",
  null
  
)

export default component.exports